import { render } from "./MapboxGL.vue?vue&type=template&id=2478bb72"
import script from "./MapboxGL.vue?vue&type=script&lang=js"
export * from "./MapboxGL.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__